import {
  ReportDashboardComponentKind,
  ReportDashboardComponentViewMode,
  VisualizationType,
  type ReportDashboardComponentViewData,
} from '@core/reports-types';

export type GetComponentVisualizationTypeInput = Pick<
  ReportDashboardComponentViewData,
  'viewMode' | 'kind' | 'primaryGroup' | 'secondaryGroup' | 'metric'
>;

// TODO CU-86c4x5z1z
// Metrics that are implicitly grouped by the backend
// and should be treated as PivotTable when primaryGroup is set.
// To be removed in the future
export const KiwiImplicitlyGroupedMetrics = ['average_salary', 'total_salary'];

export const getComponentVisualizationType = (
  component: GetComponentVisualizationTypeInput,
): VisualizationType => {
  switch (component.viewMode) {
    case ReportDashboardComponentViewMode.Chart: {
      return VisualizationType.Chart;
    }
    case ReportDashboardComponentViewMode.Summary: {
      return VisualizationType.Summary;
    }
    case ReportDashboardComponentViewMode.Table: {
      if (component.kind === ReportDashboardComponentKind.Breakdown && component.secondaryGroup) {
        return VisualizationType.PivotTable;
      }
      if (component.kind === ReportDashboardComponentKind.Trend && component.primaryGroup) {
        return VisualizationType.PivotTable;
      }
      // TODO the solution could and should be more generic, maybe backend driven. CU-86c4x5z1z
      if (KiwiImplicitlyGroupedMetrics.includes(component.metric) && component.primaryGroup) {
        return VisualizationType.PivotTable;
      }
      return VisualizationType.Table;
    }
    default: {
      throw new Error('Unknown view mode:', component.viewMode);
    }
  }
};
